import { render, staticRenderFns } from "./ModalCreateCategory.vue?vue&type=template&id=078f3055"
import script from "./ModalCreateCategory.vue?vue&type=script&lang=js"
export * from "./ModalCreateCategory.vue?vue&type=script&lang=js"
import style0 from "./ModalCreateCategory.vue?vue&type=style&index=0&id=078f3055&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports